import React from 'react';
import { useLocation } from 'react-router-dom';
import SideBar from '../../components/SideBar';
import NavBarTop from '../../components/NavBarTop';
import Content from '../../components/Content';
import { Container, Spinner } from 'react-bootstrap';
import styles from './Root.module.scss';
import Breadcrumbs from '../../Routes/Breadcrumbs';
import { SidebarProvider } from '../../contexts/SidebarContext';
import { useRequireUser } from '../../hooks/useRequireUser';

const Root: React.FC = () => {
    const location = useLocation();
    
    // Se estamos em /login, não executa useRequireUser para evitar sobrescrever redirect
    if (location.pathname === '/login') {
        return null;
    }
    
    const { user, userLoading } = useRequireUser();

    if (userLoading || !user) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spinner animation="border" />
                <span className="ms-2">Carregando...</span>
            </div>
        );
    }
    return (
        <SidebarProvider>
            <div className={styles.ContainerStyle}>
                <SideBar user={user} />
                <main className={styles.MainStyle}>
                    <NavBarTop user={user} />
                    <Container fluid>
                        <div style={{ marginLeft: '25px', display: 'flex' }}>
                            <div style={{ marginLeft: '8px' }}></div>
                            <Breadcrumbs />
                        </div>
                        <Content />
                        <br />
                    </Container>
                </main>
            </div>
        </SidebarProvider>
    );
};

export default Root;
